import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from 'recharts';

const CpuUsageChart = ({ data, summary }) => {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`;
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'healthy':
        return 'text-green-500';
      case 'degraded':
        return 'text-orange-500';
      case 'unhealthy':
        return 'text-error';
      default:
        return 'text-gray-500';
    }
  };

  // Calculate average CPU usage
  const avgCpuUsage = data?.length > 0
    ? Math.round(data.reduce((sum, item) => sum + (item.avgCpuPercentage || 0), 0) / data.length)
    : 0;

  return (
    <div className="flex flex-col card-container rounded-md p-2 sm:p-3 w-full h-full">
      <div className="flex flex-row justify-between items-center mb-2">
        <div className="text-lg font-semibold text-font-primary">CPU Usage</div>
          <div className="text-sm">Avg: <span className="font-medium font-semibold text-primary">{avgCpuUsage}%</span></div>
      </div>
      <div className="text-sm text-font-secondary mb-4">
        {summary.details}
      </div>
      <div className="h-[250px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 10, right: 10, left: -30, bottom: -5 }}>
            <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
            <XAxis 
              dataKey="day" 
              tickFormatter={formatDate} 
              stroke="#aaa"
            />
            <YAxis domain={[0, 100]} stroke="#aaa" />
            <Tooltip 
              formatter={(value) => [`${value}%`, 'CPU Usage']}
              labelFormatter={formatDate}
            />
            <ReferenceLine y={75} stroke="orange" strokeDasharray="3 3" label={{ value: 'Warning (75%)', position: 'insideTopRight', fill: 'orange', fontSize: 12 }} />
            <ReferenceLine y={90} stroke="red" strokeDasharray="3 3" label={{ value: 'Critical (90%)', position: 'insideTopRight', fill: 'red', fontSize: 12 }} />
            <Line 
              type="monotone" 
              dataKey="avgCpuPercentage" 
              stroke="#82ca9d" 
              name="CPU Usage %" 
              activeDot={{ r: 8 }} 
              strokeWidth={3}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CpuUsageChart;